export default __webpack_public_path__ + "static/media/logo-light.0bca271b.png";